<template>
  <div class="main-wrapper login-body">
    <!-- Header -->
    <header class="log-header">
      <router-link to="/">
        <img
          class="img-fluid logo-dark"
          src="@/assets/img/logo.ad0b8567.png"
          alt="الشعار"
        />
      </router-link>
    </header>
    <!-- /Header -->

    <div class="login-wrapper">
      <div class="loginbox">
        <div class="login-auth">
          <div class="login-auth-wrap">
            <div class="sign-group">
              <router-link to="/" class="btn sign-up">
                <span>
                  <i class="fe feather-corner-down-left" aria-hidden="true"></i>
                </span>
                العودة للصفحة الرئيسية
              </router-link>
            </div>

            <h1>تسجيل الدخول</h1>
            <p class="account-subtitle">
              سيتم إرسال رمز التأكيد إلى هاتفك.
            </p>

            <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
              <!-- رقم الهاتف -->
              <div class="input-block">
                <label class="form-label">
                  رقم الهاتف <span class="text-danger">*</span>
                </label>
                <Field
                  name="phone"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.phone }"
                  placeholder="أدخل رقم الهاتف"
                />
                <div class="invalid-feedback">{{ errors.phone }}</div>
              </div>

              <!-- كود الدولة -->
              <div class="input-block mt-3">
                <label class="form-label">
                  كود الدولة <span class="text-danger">*</span>
                </label>
                <Field
                  name="country_code"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.country_code }"
                  placeholder="+20"
                />
                <div class="invalid-feedback">{{ errors.country_code }}</div>
              </div>

              <!-- كلمة المرور -->
              <div class="input-block mt-3">
                <label class="form-label">
                  كلمة المرور <span class="text-danger">*</span>
                </label>
                <div class="pass-group">
                  <Field
                    name="password"
                    :type="showPassword ? 'text' : 'password'"
                    class="form-control pass-input mt-2"
                    placeholder="كلمة المرور"
                    :class="{ 'is-invalid': errors.password }"
                  />
                  <span @click="toggleShow" class="toggle-password">
                    <i
                      :class="{
                        'fas fa-eye': showPassword,
                        'fas fa-eye-slash': !showPassword,
                      }"
                    ></i>
                  </span>
                  <div class="invalid-feedback">{{ errors.password }}</div>
                </div>
              </div>

              <div class="input-block mt-3">
                <router-link
                  class="forgot-link"
                  to="/authentication/forgot-password"
                >
                  نسيت كلمة المرور؟
                </router-link>
              </div>

              <div class="input-block m-0">
                <label class="custom_check d-inline-flex">
                  <span>تذكرني</span>
                  <input type="checkbox" name="remember" />
                  <span class="checkmark"></span>
                </label>
              </div>

              <b-button
                class="primary btn-block"
                type="submit"
                :disabled="authStore.isLoading"
              >
                <span v-if="authStore.isLoading">جاري تسجيل الدخول...</span>
                <span v-else>تسجيل الدخول</span>
              </b-button>

              <div class="login-or">
                <span class="or-line"></span>
                <span class="span-or-log">أو سجّل الدخول باستخدام بريدك الإلكتروني</span>
              </div>

              <!-- Social Login -->
              <div class="social-login">
                <a
                  href="javascript:;"
                  class="d-flex align-items-center justify-content-center input-block btn google-login w-100"
                >
                  <span>
                    <img
                      src="@/assets/img/icons/google.svg"
                      class="img-fluid"
                      alt="Google"
                    />
                  </span>
                  تسجيل الدخول باستخدام جوجل
                </a>
              </div>

              <div class="social-login">
                <a
                  href="javascript:;"
                  class="d-flex align-items-center justify-content-center input-block btn google-login w-100"
                >
                  <span>
                    <img
                      src="@/assets/img/icons/facebook.svg"
                      class="img-fluid"
                      alt="Facebook"
                    />
                  </span>
                  تسجيل الدخول باستخدام فيسبوك
                </a>
              </div>
              <!-- /Social Login -->

              <div class="text-center dont-have">
                ليس لديك حساب بعد؟
                <router-link to="/authentication/register">إنشاء حساب</router-link>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <auth-footer></auth-footer>
    <!-- /Footer -->
  </div>
</template>

<script>
import { ref } from "vue";
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import { useAuthStore } from "@/stores/auth";
import { useRouter } from "vue-router"; // 

export default {
  components: {
    Form,
    Field,
  },
  setup() {
    const authStore = useAuthStore();
    const showPassword = ref(false);
    const router = useRouter(); 

    const toggleShow = () => {
      showPassword.value = !showPassword.value;
    };

    const schema = Yup.object().shape({
      phone: Yup.string().required("رقم الهاتف مطلوب"),
      country_code: Yup.string().required("كود الدولة مطلوب"),
      password: Yup.string()
        .min(5, "كلمة المرور يجب ألا تقل عن 6 أحرف")
        .required("كلمة المرور مطلوبة"),
    });

    const onSubmit = async (values) => {
      const success = await authStore.signIn(values);
      if (success) {
      router.push("/index-5");
    }
    };

    return {
      schema,
      onSubmit,
      showPassword,
      toggleShow,
      authStore,
    };
  },
};
</script>

<style scoped>
.logo-dark {
  width: 150px;
  height: auto;
}
</style>
